module.exports = __webpack_public_path__ + "img/accessory_hat_15.84742855.svg";